var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 424",
    style: {
      enableBackground: "new 0 0 512 424"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155,152.5L0.9,0H75l117,115.8c35.3,35,92.6,35,127.9,0L437,0h74L357,152.5C301.2,207.7,210.8,207.7,155,152.5z M357,270.6 c-55.8-55.2-146.2-55.2-202,0L0,424h74.1l118-116.8c35.3-35,92.6-35,127.9,0L438,424h74L357,270.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/xrp.db895f10ac96c799cd9b24edf5740538.svg";
export { ForwardRef as ReactComponent };